module.exports = "/packs/course-small-copy-writing-a15ec84e00061f67892bf21613063c84.png";